import { render, staticRenderFns } from "./StandBy.vue?vue&type=template&id=063a477c&scoped=true&"
import script from "./StandBy.vue?vue&type=script&lang=js&"
export * from "./StandBy.vue?vue&type=script&lang=js&"
import style0 from "./StandBy.vue?vue&type=style&index=0&id=063a477c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063a477c",
  null
  
)

export default component.exports